import { createContext, type ReactNode } from 'react';

export interface PromptOptions {
  title: ReactNode;
  /** Explanation shown above the field. */
  message?: ReactNode;
  /** Field label, e.g. "Reason". */
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  /** Confirm button text. Default "OK". */
  confirmLabel?: string;
  /** 'danger' for destructive actions (reject, cancel, block). */
  tone?: 'primary' | 'danger';
  /** Textarea instead of a single-line input. */
  multiline?: boolean;
  /** Blocks OK until something is typed. Default true. */
  required?: boolean;
  inputMode?: 'text' | 'decimal';
  /** false = a confirm dialog with no field; resolves '' on OK. */
  input?: boolean;
  /** Wider dialog for long messages (e.g. a list of lines). */
  wide?: boolean;
}

/** Resolves to the typed text, or null when cancelled. */
export type AskText = (opts: PromptOptions) => Promise<string | null>;

export const PromptContext = createContext<AskText | null>(null);
